import axios from "axios";
import { KeyUri } from "../key";

// Shared, cached requests so Tours, DestinationShowcase and LastMinuteEscapes
// hit the backend once instead of three times.
let toursPromise = null;
let upcomingPromise = null;

// Tiny sessionStorage cache so a revisit / refresh paints instantly while the
// fresh data is fetched in the background (stale-while-revalidate).
export const readCache = (key, maxAgeMs = 30 * 60 * 1000) => {
  try {
    const r = JSON.parse(sessionStorage.getItem(`tg:${key}`));
    if (r && Date.now() - r.t < maxAgeMs) return r.v;
  } catch (e) { /* storage unavailable or corrupt: ignore */ }
  return null;
};
export const writeCache = (key, value) => {
  try { sessionStorage.setItem(`tg:${key}`, JSON.stringify({ t: Date.now(), v: value })); } catch (e) { /* quota: ignore */ }
};
const departuresCache = new Map();

export const fetchToursCached = () => {
  if (!toursPromise) {
    toursPromise = axios
      .get(`${KeyUri.BACKEND_URI}/get-tours?view=list&available=true`)
      .then((res) => (Array.isArray(res.data) ? res.data : []))
      .catch((err) => {
        toursPromise = null; // allow retry on next mount
        throw err;
      });
  }
  return toursPromise;
};

export const fetchDeparturesCached = (tourId) => {
  if (!departuresCache.has(tourId)) {
    departuresCache.set(
      tourId,
      axios
        .get(`${KeyUri.BACKEND_URI}/get-departures/${tourId}`)
        .then((res) => res.data?.data || [])
        .catch(() => [])
    );
  }
  return departuresCache.get(tourId);
};

export const isDomesticTour = (t) =>
  t.tour_type === "domestic" ||
  (!t.tour_type && (!t.country || String(t.country).toLowerCase() === "india"));


// One shared request for the last-minute strip (deduped, cached for the session)
export const fetchUpcomingCached = (params) => {
  if (!upcomingPromise) {
    upcomingPromise = axios
      .get(`${KeyUri.BACKEND_URI}/get-upcoming-departures`, { params })
      .then((res) => { writeCache("upcoming", res.data); return res.data; })
      .catch((err) => { upcomingPromise = null; throw err; });
  }
  return upcomingPromise;
};